import { createSlice } from "@reduxjs/toolkit";

import { fetchSectionStatus } from "./actions";

export const initialState = {
  data: null,
  isLoading: false,
  error: null,
};

const DEFAULT_ERROR = "Failed to load section status";

const sectionStatusSlice = createSlice({
  name: "sectionStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSectionStatus.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchSectionStatus.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchSectionStatus.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default sectionStatusSlice.reducer;
